import logo from './logo.svg';
import './App.css';
import ProductPage from './Components/ProductPage';
import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  );
}

export default App;
